import React from 'react';
import { Router, useRouterHistory, applyRouterMiddleware } from 'react-router';
import useScroll from 'react-router-scroll/lib/useScroll';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import { createHistory } from 'history';
import routerRoutes from './components/routes';
import configureStore from '../configureStore';
import * as rootReducer from './reducers';
import { BASE_NAME } from './base';

const store = configureStore(rootReducer, { client: true, initialData: window.__INITIAL_STATE__ });

const renderApp = (routes) => {
  render(
    <AppContainer>
      <Provider store={store}>
        <Router
          history={useRouterHistory(createHistory)({
            basename: `/${BASE_NAME}`,
          })}
          render={applyRouterMiddleware(useScroll(() => [0, 0]))}
          routes={routes} />
      </Provider>
    </AppContainer>,
    document.getElementById(`${BASE_NAME}-root`),
  );
};

renderApp(routerRoutes);

if (module.hot) {
  module.hot.accept('./components/routes', () => {
    const newRoutes = require('./components/routes').default;
    renderApp(newRoutes);
  });
}

export const bundleName = BASE_NAME;
